import { useState, useEffect } from 'react';
import { set, get, difference } from 'lodash';
import { IconSelector, Grid, Typography, Select } from '@ts/storybook';
import { DateTimeInput, TextInput } from '@components/Inputs';
import { typeRuleOperationsMap } from './utils';
import { IIcon } from '@ts/ui-models';

interface IconRuleFormProps {
  values: any;
  onChange: (value: any) => void;
  possibleValues: string[];
  alreadyInUseOperands: string[];
  type: string;
}

const IconRuleForm = (props: IconRuleFormProps) => {
  const [operation, setOperation] = useState<any>(null);
  const [icon, setIcon] = useState<Partial<IIcon>>(props.values?.icon || { name: '', color: '#000000' });
  const allowedValues: string[] = difference(props.possibleValues, props.alreadyInUseOperands);

  const handleChangeIconRule = path => value => {
    let newState = { ...props.values };

    newState.rule = { ...newState.rule, operation };
    newState.icon = { ...newState.icon, color: icon.color };
    set(newState, path, value);
    props.onChange(newState);
  };

  const renderOperand = () => {
    const operandValue = props.values?.rule?.operand ?? '';

    switch (props.type) {
      case 'list':
      case 'boolean':
        return (
          <Select
            label={'Operand'}
            value={operandValue}
            onChange={handleChangeIconRule('rule.operand')}
            options={allowedValues.map(pv => ({ label: pv + '', value: pv }))}
          />
        );
      case 'float':
      case 'integer':
        return (
          <TextInput
            type="number"
            label={'Operand'}
            value={operandValue || null}
            onChangeValue={handleChangeIconRule('rule.operand')}
          />
        );
      case 'string':
        return <TextInput label={'Operand'} value={operandValue} onChangeValue={handleChangeIconRule('rule.operand')} />;
      case 'timestamp':
        return (
          <DateTimeInput
            onChange={handleChangeIconRule('rule.operand')}
            value={operandValue}
            labelDate={'Date'}
            labelTime={'Time'}
          />
        );
      case 'date':
        return (
          <DateTimeInput
            onlyDate
            labelDate={'Date'}
            value={operandValue}
            onChange={handleChangeIconRule('rule.operand')}
            style={{ minWidth: '90px' }}
          />
        );
      case 'time':
        return (
          <DateTimeInput
            onlyTime
            labelTime={'Time'}
            value={operandValue}
            onChange={handleChangeIconRule('rule.operand')}
            style={{ minWidth: '90px' }}
          />
        );
    }
  };

  useEffect(() => {
    //handleChangeIconRule('rule.operation')(operation);

    setTimeout(() => {
      difference(props.possibleValues, props.alreadyInUseOperands);

      handleChangeIconRule('rule.operand')(allowedValues?.[0] || '');
    }, 200);
  }, [operation]);

  useEffect(() => {
    handleChangeIconRule('icon.color')(icon.color);
  }, [icon.color]);

  useEffect(() => {
    handleChangeIconRule('icon.name')(icon.name);
  }, [icon.name]);

  const possibleOperations = typeRuleOperationsMap[props.type] || [];

  return (
    <Grid container justifyContent={'center'} spacing={2}>
      <Grid container size={8} mt={2} spacing={2}>
        <Grid size={12}>
          <Typography variant="h6" gutterBottom text="Rule definition" />
        </Grid>
        <Grid size={6}>
          <Select
            label={'Operation'}
            value={props.values?.rule?.operation || ''}
            onChange={v => setOperation(v)}
            options={possibleOperations.map(op => ({ label: op, value: op }))}
          />
        </Grid>
        <Grid size={6}>{renderOperand()}</Grid>
      </Grid>
      <Grid container size={8} mt={2} justifyContent={'center'}>
        <Grid size={12}>
          <Typography variant="h6" text={['Selected icon']} />
        </Grid>
        <IconSelector {...props} onChangeIcon={setIcon} defaultIcon={icon} />
      </Grid>
    </Grid>
  );
};

export default IconRuleForm;
